module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay-in__body px-4 py-3 d-flex flex-column"
  }, [(_vm.createdPayments.length && !_vm.showPaymentDetailsForm) ? _c('created-partial-payment-list', {
    staticClass: "mb-3",
    attrs: {
      "payments": _vm.createdPayments,
      "showAddPayment": true,
      "disableAdd": _vm.remainingAmountDue <= 0
    },
    on: {
      "remove": _vm.removeCreatedPayment,
      "edit": _vm.editCreatedPayment,
      "add": function($event) {
        return _vm.$emit('update:showPaymentDetailsForm', true)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPaymentDetailsForm) ? [_c('div', {
    staticClass: "mb-1"
  }, [_c('label', {
    staticClass: "mb-1 font-weight-600 darkest"
  }, [_vm._v("Reservation Items")]), _vm._v(" "), _c('div', {
    staticClass: "pay-in__tables-wrapper"
  }, [(_vm.paxItems.length) ? [_c('table', {
    staticClass: "w-100 dark mb-3 pay-in__items-table"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.paxItems), function(item, index) {
    return _c('tr', {
      key: 'pax-' + index,
      staticClass: "border-bottom-light"
    }, [_c('td', {
      staticClass: "darker py-0"
    }, [_vm._v(_vm._s(item.audienceTypeDescription))]), _vm._v(" "), _c('td', {
      staticClass: "py-0"
    }, [_vm._v(_vm._s(item.sellerName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center py-0"
    }, [_vm._v(_vm._s(item.remainingQty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center py-0"
    }, [_vm._v(_vm._s(_vm.formatPrice(_vm.getItemPrice(item))) + " €")]), _vm._v(" "), _c('td', {
      staticClass: "text-center py-0"
    }, [_c('div', {
      staticClass: "pay-in__qty-control"
    }, [_c('span', {
      staticClass: "border-light radius-normal mx-1 text-center pointer pay-in__qty-btn",
      on: {
        "click": function($event) {
          return _vm.decrementItemQuantity(item)
        }
      }
    }, [_c('i', {
      staticClass: "ico ico-minus dark m-0 pay-in__qty-icon"
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (item.qtyToAdd),
        expression: "item.qtyToAdd",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "text-center px-0 py-0 bg-lighter darker pay-in__qty-input",
      attrs: {
        "type": "number",
        "placeholder": "0",
        "min": item.minQty || 0
      },
      domProps: {
        "value": (item.qtyToAdd)
      },
      on: {
        "change": function($event) {
          return _vm.keepSelectedQuantityInBounds(item)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "qtyToAdd", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "border-light radius-normal mx-1 text-center pointer pay-in__qty-btn",
      on: {
        "click": function($event) {
          return _vm.incrementItemQuantity(item)
        }
      }
    }, [_c('i', {
      staticClass: "ico ico-add dark m-0 pay-in__qty-icon"
    })])])]), _vm._v(" "), _c('td', {
      staticClass: "text-right py-0"
    }, [_vm._v(_vm._s(_vm.formatPrice(item.qtyToAdd * _vm.getItemPrice(item))) + " €")])])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.extraItems.length) ? [_c('table', {
    staticClass: "w-100 dark mb-3 pay-in__items-table"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._l((_vm.extraItems), function(item, index) {
    return _c('tr', {
      key: 'extra-' + index,
      staticClass: "border-bottom-light"
    }, [_c('td', {
      staticClass: "darker py-0"
    }, [_vm._v(_vm._s(item.component.name) + " - " + _vm._s(item.componentPrice.name))]), _vm._v(" "), _c('td', {
      staticClass: "py-0"
    }, [_vm._v(_vm._s(item.sellerName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center py-0"
    }, [_vm._v(_vm._s(item.remainingQty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center py-0"
    }, [_vm._v(_vm._s(_vm.formatPrice(_vm.getItemPrice(item.componentPrice))) + " €")]), _vm._v(" "), _c('td', {
      staticClass: "text-center py-0"
    }, [_c('div', {
      staticClass: "pay-in__qty-control"
    }, [_c('span', {
      staticClass: "border-light radius-normal mx-1 text-center pointer pay-in__qty-btn",
      on: {
        "click": function($event) {
          return _vm.decrementItemQuantity(item)
        }
      }
    }, [_c('i', {
      staticClass: "ico ico-minus dark m-0 pay-in__qty-icon"
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (item.qtyToAdd),
        expression: "item.qtyToAdd",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "text-center px-0 py-0 bg-lighter darker pay-in__qty-input",
      attrs: {
        "type": "number",
        "placeholder": "0",
        "min": "0"
      },
      domProps: {
        "value": (item.qtyToAdd)
      },
      on: {
        "change": function($event) {
          return _vm.keepSelectedQuantityInBounds(item)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "qtyToAdd", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "border-light radius-normal mx-1 text-center pointer pay-in__qty-btn",
      on: {
        "click": function($event) {
          return _vm.incrementItemQuantity(item)
        }
      }
    }, [_c('i', {
      staticClass: "ico ico-add dark m-0 pay-in__qty-icon"
    })])])]), _vm._v(" "), _c('td', {
      staticClass: "text-right py-0"
    }, [_vm._v(_vm._s(_vm.formatPrice(item.qtyToAdd * _vm.getItemPrice(item.componentPrice))) + " €")])])
  })], 2)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "text-right fs-small dark pay-in__tables-total"
  }, [_vm._v("Total: " + _vm._s(_vm.formatPrice(_vm.itemsTotal)) + " €")])]), _vm._v(" "), _c('hr', {
    staticClass: "pay-in__separator mb-2"
  }), _vm._v(" "), _c('payment-method-form', {
    attrs: {
      "payments": _vm.paymentFormEntries,
      "isAmountCovered": _vm.isItemsTotalFullyPaid,
      "remainingToPay": _vm.itemsTotal,
      "allowEmpty": !!_vm.editPayment
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "pay-in__separator mb-2"
  }), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "ml-2 d-flex align-items-center"
  }, [_vm._m(5), _vm._v(" "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: 'A custom identifier for easy payment recognition.',
        html: true
      }),
      expression: "{\n                        content: 'A custom identifier for easy payment recognition.',\n                        html: true\n                    }"
    }],
    staticClass: "fa fa-info-circle fs-normal dark has-tooltip ml-2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pay-in__notes-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.reference),
      expression: "form.reference",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "pay-in__notes-input",
    attrs: {
      "type": "text",
      "maxlength": _vm.REFERENCE_CHARACTER_LIMIT
    },
    domProps: {
      "value": (_vm.form.reference)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "reference", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pay-in__notes-counter"
  }, [_vm._v("\n                    " + _vm._s((_vm.form.reference && _vm.form.reference.length) || 0) + "/" + _vm._s(_vm.REFERENCE_CHARACTER_LIMIT) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-1"
  }, [_c('label', {
    staticClass: "ml-2"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('div', {
    staticClass: "pay-in__notes-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.notes),
      expression: "form.notes"
    }],
    staticClass: "pay-in__notes-input",
    attrs: {
      "type": "text",
      "maxlength": _vm.NOTES_CHARACTER_LIMIT
    },
    domProps: {
      "value": (_vm.form.notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "notes", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pay-in__notes-counter"
  }, [_vm._v("\n                    " + _vm._s(_vm.form.notes.length || 0) + "/" + _vm._s(_vm.NOTES_CHARACTER_LIMIT) + "\n                ")])])]), _vm._v(" "), _c('hr', {
    staticClass: "pay-in__separator mb-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-2"
  }, [(_vm.isItemsTotalFullyPaid && _vm.showInvoice) ? _c('div', {
    staticClass: "pay-in__checkbox mb-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.createInvoice),
      expression: "form.createInvoice"
    }],
    attrs: {
      "type": "checkbox",
      "id": "createInvoicePartial"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.createInvoice) ? _vm._i(_vm.form.createInvoice, null) > -1 : (_vm.form.createInvoice)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.createInvoice,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "createInvoice", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "createInvoice", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "createInvoice", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mb-0 pay-in__checkbox-label",
    attrs: {
      "for": "createInvoicePartial"
    }
  }, [_vm._v("\n                    Create invoice after saving\n                ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pay-in__checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.addBillingDetails),
      expression: "form.addBillingDetails"
    }],
    attrs: {
      "type": "checkbox",
      "id": "addBillingDetailsPartial"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.addBillingDetails) ? _vm._i(_vm.form.addBillingDetails, null) > -1 : (_vm.form.addBillingDetails)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.addBillingDetails,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "addBillingDetails", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "addBillingDetails", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "addBillingDetails", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mb-0 pay-in__checkbox-label",
    attrs: {
      "for": "addBillingDetailsPartial"
    }
  }, [_vm._v("\n                    Add billing details\n                ")])])]), _vm._v(" "), (_vm.form.addBillingDetails) ? _c('billing-details-form', {
    attrs: {
      "billingDetails": _vm.form.billingDetails
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.editPayment) ? _c('div', {
    staticClass: "mt-3 mb-3"
  }, [_c('button', {
    staticClass: "btn green pay-in__create-btn",
    attrs: {
      "type": "button",
      "disabled": !_vm.isItemsTotalFullyPaid || !_vm.isBillingValid || !_vm.isReferenceValid || _vm.hasRedLabels
    },
    on: {
      "click": _vm.createPayment
    }
  }, [(!_vm.isEditingPayment) ? _c('i', {
    staticClass: "ico-add fs-smallest mr-1"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.isEditingPayment ? 'Update payment' : 'Create payment') + "\n            ")])]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center mt-auto pt-2"
  }, [_c('label', {
    staticClass: "mr-2"
  }, [_vm._v("Due to Pay")]), _vm._v(" "), _c('span', {
    staticClass: "fs-large font-weight-600 mr-4"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.remainingAmountDue)) + " €")]), _vm._v(" "), _c('label', {
    staticClass: "mr-2"
  }, [_vm._v("Total")]), _vm._v(" "), _c('span', {
    staticClass: "fs-large font-weight-600"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.grandTotal)) + " €")])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticClass: "col-description"
  }), _c('col', {
    staticClass: "col-seller"
  }), _c('col', {
    staticClass: "col-qty"
  }), _c('col', {
    staticClass: "col-price"
  }), _c('col', {
    staticClass: "col-qtyadd"
  }), _c('col', {
    staticClass: "col-total"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "dark border-bottom-light"
  }, [_c('th', {
    staticClass: "py-0"
  }, [_vm._v("Ticket Type")]), _vm._v(" "), _c('th', {
    staticClass: "py-0"
  }, [_vm._v("Seller")]), _vm._v(" "), _c('th', {
    staticClass: "py-0 text-center"
  }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
    staticClass: "py-0 text-center"
  }, [_vm._v("Price/unit")]), _vm._v(" "), _c('th', {
    staticClass: "py-0 text-center"
  }, [_vm._v("Qty. to add")]), _vm._v(" "), _c('th', {
    staticClass: "py-0 text-right"
  }, [_vm._v("Total")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', [_c('col', {
    staticClass: "col-description"
  }), _c('col', {
    staticClass: "col-seller"
  }), _c('col', {
    staticClass: "col-qty"
  }), _c('col', {
    staticClass: "col-price"
  }), _c('col', {
    staticClass: "col-qtyadd"
  }), _c('col', {
    staticClass: "col-total"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "py-0 darker",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("Extras")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "dark border-bottom-light"
  }, [_c('th', {
    staticClass: "py-0"
  }, [_vm._v("Description")]), _vm._v(" "), _c('th', {
    staticClass: "py-0"
  }, [_vm._v("Seller")]), _vm._v(" "), _c('th', {
    staticClass: "py-0 text-center"
  }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
    staticClass: "py-0 text-center"
  }, [_vm._v("Price/unit")]), _vm._v(" "), _c('th', {
    staticClass: "py-0 text-center"
  }, [_vm._v("Qty. to add")]), _vm._v(" "), _c('th', {
    staticClass: "py-0 text-right"
  }, [_vm._v("Total")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("Payment ID "), _c('span', {
    staticClass: "pay-in__required"
  }, [_vm._v("*")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-16ab3ee0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16ab3ee0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationPayIn/Step2PartialItems.vue
// module id = 2020
// module chunks = 0